import "./polyfills/includes.js"
import "react-app-polyfill/ie11"
import "./polyfills/find.js"
import "./polyfills/findIndex.js"
import { initialize } from "./initialize"
import MainRouter from "./routes/MainRouter"

initialize(MainRouter)
